export default {
  title: "מאגר ידע",
  description: "ניהול וחיפוש פריטי ידע",

  // Search
  searchPlaceholder: "חיפוש בתוכן ובכותרות...",
  searchResults: "תוצאות חיפוש",
  noResults: "לא נמצאו תוצאות",
  resultsCount: "{count} תוצאות",

  // Filters
  filters: "מסננים",
  filterByType: "סינון לפי סוג",
  filterByStatus: "סינון לפי סטטוס",
  filterByDepartment: "סינון לפי מחלקה",
  filterByStream: "סינון לפי זרם",
  filterByOwner: "סינון לפי בעלים",
  allTypes: "כל הסוגים",
  allStatuses: "כל הסטטוסים",
  allDepartments: "כל המחלקות",
  allStreams: "כל הזרמים",
  allOwners: "כל הבעלים",
  resetFilters: "איפוס מסננים",

  // Sorting
  sortBy: "מיון לפי",
  sortNewest: "חדש ביותר",
  sortOldest: "ישן ביותר",
  sortPriority: "עדיפות",
  sortConfidence: "רמת ביטחון",
  sortTitle: "כותרת",

  // Card display
  showMore: "הצג עוד",
  showLess: "הצג פחות",
  createdAt: "נוצר בתאריך",
  updatedAt: "עודכן בתאריך",
  author: "מחבר",
  confidence: "רמת ביטחון",
  priority: "עדיפות",
  type: "סוג",
  departments: "מחלקות",
  streams: "זרמים",
  tags: "תגיות",

  // Status badges
  draft: "טיוטה",
  classified: "מסווג",
  reviewed: "נבדק",
  approved: "מאושר",
  locked_to_sot: "נעול למקור אמת",
  deprecated: "מיושן",
  archived: "בארכיון",
  rejected: "נדחה",

  // Confidence badges
  low: "נמוך",
  medium: "בינוני",
  high: "גבוה",
  verified: "מאומת",

  // Priority badges
  critical: "קריטי",
  priorityHigh: "גבוה",
  normal: "רגיל",

  // Owner domains
  case_preparation: "הכנת תיקים",
  sales: "מכירות",
  recruitment: "גיוס",
  finance: "כספים",
  systems: "מערכות",
  management: "הנהלה",

  // Actions
  addNew: "הוסף פריט חדש",
  edit: "עריכה",
  delete: "מחיקה",
  export: "יצוא",
  refresh: "רענון",
  viewDetails: "צפייה בפרטים",

  // Detail view
  fullContent: "תוכן מלא",
  metadata: "מטא-דאטה",
  lifecycle: "מחזור חיים",
  sourceInfo: "מידע מקור",
  relations: "קשרים",
  linkedItems: "פריטים קשורים",
  useCases: "מקרי שימוש",
  lenses: "עדשות",
  reviewInfo: "מידע בדיקה",
  needsResolution: "דרושה פתרון",
  validUntil: "תקף עד",
  reviewDue: "מועד בדיקה",
  sotLevel: "רמת מקור אמת",
  visibility: "נראות",

  // Add new form
  newKnowledgeItem: "פריט ידע חדש",
  titleRequired: "כותרת נדרשת",
  contentRequired: "תוכן נדרש",
  selectType: "בחר סוג",
  selectDepartments: "בחר מחלקות",
  selectStreams: "בחר זרמים",
  selectUseCases: "בחר מקרי שימוש",
  selectLenses: "בחר עדשות",
  selectOwner: "בחר בעלים",
  tagsPlaceholder: "הוסף תגיות מופרדות בפסיק...",
  save: "שמור",
  cancel: "ביטול",
  saving: "שומר...",

  // Visibility options
  internal: "פנימי",
  ai_internal: "AI פנימי",
  ai_external: "AI חיצוני",
  published: "מפורסם",

  // Stats
  totalItems: "סה\"כ פריטים",
  draftCount: "טיוטות",
  approvedCount: "מאושרים",
  needsReview: "דורש בדיקה",
  expiringSoon: "פג תוקף בקרוב",

  // Messages
  loadingItems: "טוען פריטי ידע...",
  errorLoading: "שגיאה בטעינת פריטים",
  itemSaved: "פריט נשמר בהצלחה",
  itemDeleted: "פריט נמחק בהצלחה",
  errorSaving: "שגיאה בשמירת פריט",
  confirmDelete: "האם אתה בטוח שברצונך למחוק פריט זה?",

  // ─── ספריית המחקר ───
  research: {
    title: "ספריית המחקר",
    subtitle: "מידע חיצוני, מייעץ בלבד — אינו הופך לחוק פנימי מעצמו",
    verdictEmpty: "אין עדיין מקורות בספרייה",
    verdictDue: "{count} מקורות דורשים בדיקה חוזרת",
    verdictUndecided: "{count} מקורות ממתינים להכרעה",
    verdictClear: "{count} מקורות בספרייה — הכל עדכני ומוכרע",
    lensMissing: "עדשת המחקר עדיין לא הותקנה במסד",
    lensMissingHint: "הריצו את המיגרציה 20260827120000_research_library_seed ואז רעננו את הדף",
    empty: "אין מקורות שתואמים את הסינון",
    emptyHint: "נקו את המסננים או הוסיפו מקור חדש לספרייה",
    loading: "טוען מקורות...",
    errorLoading: "שגיאה בטעינת המקורות",
    errorLoadingHint: "בדקו את החיבור למסד ונסו לרענן",
    searchPlaceholder: "חיפוש בכותרת ובתוכן...",
    // KPI
    kpiSources: "מקורות",
    kpiUndecided: "ממתינים להכרעה",
    kpiDue: "דורשים בדיקה",
    kpiDomains: "תחומים",
    // שדות
    openSource: "פתיחת המקור",
    unsafeUrl: "כתובת נחסמה לתצוגה",
    checkedAt: "נבדק",
    neverChecked: "טרם נבדק",
    purpose: "למה משמש",
    audience: "למי מיועד",
    // מסננים
    allDomains: "כל התחומים",
    allAuthorities: "כל סוגי הסמכות",
    allStances: "כל ההכרעות",
    allFreshness: "כל מצבי הבדיקה",
    // סוג סמכות
    authority: {
      official: "תיעוד רשמי",
      framework: "מסגרת מושגית",
      learning_map: "מפת למידה",
      community: "ניסיון מהקהילה",
    },
    // הכרעה
    stance: {
      adopt: "מאמצים",
      reject: "דוחים",
      watch: "עוקבים",
      have_already: "כבר קיים אצלנו",
      partial: "חלקית",
      undecided: "טרם הוכרע",
    },
    // טריות
    freshness: {
      fresh: "עדכני",
      due: "לבדיקה",
      overdue: "באיחור",
      unknown: "לא ידוע",
    },
  },

  // ─── מדף המקורות ───
  sources: {
    title: "מדף המקורות",
    subtitle: "מקור אחד, ולידו כל מה שנקצר ממנו בפועל — לא מה שהתכוונו לקצור",
    loading: "טוען את המדף...",
    errorLoading: "שגיאה בטעינת המדף",
    errorLoadingHint: "בדקו את החיבור למסד ונסו לרענן",
    searchPlaceholder: "חיפוש בשם המקור, במחבר ובהערות...",
    verdictEmpty: "אין עדיין מקורות במדף",
    verdictOrphans: "{count} פריטי ידע אינם קשורים לאף מקור",
    verdictWaiting: "{count} פריטים ממתינים לשער האישור",
    verdictEmptyShelves: "{count} מקורות רשומים אך עוד לא נקצר מהם דבר",
    verdictClear: "{sources} מקורות ו-{items} פריטים — הכל קשור ומאושר",
    verdictTruncated: "השליפה נחתכה — המספרים שלמטה חלקיים",
    kpiSources: "מקורות",
    kpiItems: "פריטי ידע",
    kpiWaiting: "ממתינים לשער",
    kpiOrphans: "פריטים יתומים",
    allKinds: "כל סוגי המקור",
    allTrust: "כל רמות האמון",
    allGates: "כל מצבי השער",
    noMatch: "אין מקורות שתואמים את הסינון",
    noMatchHint: "נקו את המסננים כדי לראות את המדף המלא",
    truncatedTitle: "המדף גדול מהשליפה",
    truncatedHint: "נשלפו 1000 פריטים בלבד. ספירת המקטעים, הפריטים היתומים ופסק הדין אינם משקפים את התמונה המלאה",
    orphanTitle: "יש פריטים בלי מקור",
    orphanHint: "{count} פריטים אינם משויכים לאף שורה במדף, ולכן אי אפשר לדעת מאיפה הם באו",
    harvested: "{items} דברים שנלמדו מהמקור",
    harvestedChunks: "מתוך {chunks} קטעי טקסט מקוריים",
    fillsGap: "סוגר את הפער",
    notes: "הערות",
    nothingHarvested: "עוד לא נקצר דבר מהמקור הזה",
    origin: "מקור השורה",
    sotLevel: "רמה {level}",
    untypedGroup: "בלי סיווג",
    pickSource: "בחרו מקור מהרשימה כדי לקרוא את מה שנלמד ממנו",
    pickSourceHint: "הקורא נשאר במקומו בזמן שגוללים ברשימה",
    closeReader: "סגירת הקורא",
    sourceId: "מזהה המופע",
    copyId: "לחיצה מעתיקה את המזהה",
    copied: "הועתק",
    showOrigin: "הצגת הטקסט המקורי",
    hideOrigin: "הסתרת הטקסט המקורי",
    originTitle: "הטקסט שממנו נכתב הפריט",
    originLoading: "טוען את הטקסט המקורי...",
    originMissing: "לא נשמר טקסט מקור לפריט הזה",
    originError: "שליפת הטקסט המקורי נכשלה. זו תקלה, לא היעדר מקור",
    originInvalid: "הפניית המקור שגויה או אינה נתמכת ולכן לא נשלפה",
    addSource: "הוספת מקור",
    addSourceTitle: "מקור חדש למדף",
    addSourceHint: "המקור נרשם ריק. הקצירה ממנו היא שלב נפרד",
    formTitle: "שם המקור",
    formSlug: "מזהה באנגלית",
    formSlugHint: "אותיות אנגליות ומקפים בלבד, ייחודי במדף",
    formAuthor: "מחבר",
    formYear: "שנה",
    formUrl: "קישור",
    formKind: "סוג המקור",
    formPriority: "דחיפות",
    formTrust: "רמת אמון",
    formFillsGap: "איזה פער זה סוגר",
    formNotes: "הערות",
    formSubmit: "שמירת המקור",
    formCancel: "ביטול",
    formSaving: "שומר...",
    formRequired: "שם המקור ומזהה באנגלית הם שדות חובה",
    formDuplicate: "המזהה הזה כבר תפוס במדף",
    priority: {
      now: "עכשיו",
      soon: "בקרוב",
      someday: "מתישהו",
    },
    kind: {
      book: "ספר",
      article: "מאמר",
      framework: "מסגרת מושגית",
      internal_wiki: "ויקי פנימי",
      gam_experience: "ניסיון GAM",
      ai_conversation: "שיחת AI",
      external_reference: "מקור חיצוני",
    },
    trust: {
      authoritative: "מחייב",
      advisory: "מייעץ",
    },
    gate: {
      waiting: "ממתין לאישור",
      approved: "אושר",
      empty: "ריק",
    },
    status: {
      draft: "טיוטה",
      classified: "מסווג",
      reviewed: "נסקר",
      approved: "מאושר",
      locked_to_sot: "נעול כמקור אמת",
      deprecated: "הוצא משימוש",
      archived: "בארכיון",
      rejected: "נדחה",
    },
  },
} as const;
